import React from 'react';
import { useTranslation } from 'react-i18next';
import { useQuery } from '@tanstack/react-query';
import { fetchEntryPoints } from '@/services/campaign';
import { Select, SelectContent, SelectItem, SelectTrigger, SelectValue } from '@/components/ui/select';
import { Spinner } from '@/components/ui/spinner';
import { cn } from '@/lib/utils';
export const EntryPointSelector = ({ className, label, campaign, value, onChange, }) => {
    const { t } = useTranslation();
    const { data = [], isPending } = useQuery({
        queryKey: ['campaign-entry-points', campaign],
        queryFn: () => (campaign ? fetchEntryPoints(campaign.publicId) : []),
        enabled: !!campaign,
    });
    if (!campaign) {
        return null;
    }
    if (isPending) {
        return <Spinner />;
    }
    return (<div className={cn('flex flex-col gap-2', className)}>
            {label && <p className="text-xs text-muted-foreground">{label}</p>}
            <Select value={value} onValueChange={(value) => onChange?.(value)} disabled={data.length === 0}>
                <SelectTrigger>
                    <SelectValue placeholder={t('placeholder.select.entry_point', { ns: 'glossary' })}/>
                </SelectTrigger>
                <SelectContent>
                    <SelectItem value="all">{t('placeholder.select.entry_point', { ns: 'glossary' })}</SelectItem>
                    {data.map((entryPoint) => (<SelectItem value={entryPoint.publicId} key={entryPoint.publicId}>
                            {entryPoint.name}
                        </SelectItem>))}
                </SelectContent>
            </Select>
        </div>);
};
EntryPointSelector.displayName = 'EntryPointSelector';
